import { useCallback, useRef } from 'react'
import { useFormikContext, getIn } from 'formik'

export function useFormikHelpers<T = any>() {
  const formik = useFormikContext<T>()

  // Use a ref so getValue always reads the latest values
  // without changing its reference on every render
  const valuesRef = useRef(formik.values)
  valuesRef.current = formik.values

  const getValue = useCallback(
    (fieldName: string) => {
      return getIn(valuesRef.current, fieldName)
    },
    [] // stable reference - reads latest values via ref
  )

  const setValue = useCallback(
    (field: string, value: any) => {
      formik.setFieldValue(field, value)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [formik.setFieldValue] // setFieldValue is stable in Formik
  )

  return { ...formik, getValue, setValue }
}
